import useSWR, { SWRResponse, Key } from 'swr';
import { AxiosError } from 'axios';

import {
  Parameter$getReservationFlowMerchantReservationStats,
  Response$getReservationFlowMerchantReservationStats$Status$200,
} from '../../../../openapi/generated/apiClient';
import { useClientSideApiClient } from '../../../../openapi/axiosClient';

export interface UseGetReservationFlowMerchantReservationStatsParams {
  parameter: Parameter$getReservationFlowMerchantReservationStats;
  isDisabled?: boolean;
}

export type UseGetReservationFlowMerchantReservationStatsValue = SWRResponse<
  Response$getReservationFlowMerchantReservationStats$Status$200['application/json'],
  AxiosError
>;

export const getReservationFlowMerchantReservationStatsKey: (params: {
  parameter: Parameter$getReservationFlowMerchantReservationStats;
}) => Key = ({ parameter }) => {
  return {
    path: `/api/reservation_flow/merchants/{merchant_public_id}/event_scheme/reservation_stats`,
    parameter,
  };
};

export const useGetReservationFlowMerchantReservationStats: (
  params: UseGetReservationFlowMerchantReservationStatsParams,
) => UseGetReservationFlowMerchantReservationStatsValue = ({
  parameter,
  isDisabled,
}) => {
  const client = useClientSideApiClient();
  const key = !isDisabled
    ? getReservationFlowMerchantReservationStatsKey({ parameter })
    : null;

  const fetcher: () => Promise<
    Response$getReservationFlowMerchantReservationStats$Status$200['application/json']
  > = async () => {
    return client.getReservationFlowMerchantReservationStats({
      parameter,
    });
  };

  return useSWR(key, fetcher);
};
